import React, { useState } from 'react';
import { ButtonBase } from '@material-ui/core';
import { GlobalHistory } from '../../../../Helper';
import { UnitsOperationTypeEnum } from '../../../../Enums';

function UnitRefNumbersPreview({ data }) {
  const [showAll, setShowAll] = useState(false);

  const unitRefNumbers = data?.proposalUnitsDetails || [];
  const visibleUnits = showAll ? unitRefNumbers : unitRefNumbers.slice(0, 2);
  const shouldShowToggle = unitRefNumbers.length > 2;

  const handleUnitClick = (unit) => {
    if (unit.operationType === UnitsOperationTypeEnum.sale.key) {
      GlobalHistory.push(
        `/home/units-sales/unit-profile-edit?formType=${1}&id=${
          unit.unitId
        }&operationType=430`
      );
    } else {
      GlobalHistory.push(
        `/home/units-lease/unit-profile-edit?formType=${1}&id=${
          unit.unitId
        }&operationType=431`
      );
    }
  };


  return (
    <div className='flex fa-center flex-wrap gap-1'>
      {visibleUnits.map((unit, index) => (
        <div
          key={index}
          className='mb-1'
        >
          <ButtonBase onClick={() => handleUnitClick(unit)}>
            <div className='icon-container mx-1'>
              <span className='mdi mdi-open-in-new c-primary'></span>
            </div>
            {unit.unitRefNumber}
          </ButtonBase>
        </div>
      ))}

      {shouldShowToggle && (
        <ButtonBase
          className='btns mb-1'
          onClick={() => setShowAll((prev) => !prev)}
        >
          {showAll ? 'View Less' : 'View More'}
          <span
            className={`mdi ${
              showAll ? 'mdi-chevron-double-up' : 'mdi-chevron-double-down'
            }`}
          ></span>
        </ButtonBase>
      )}
    </div>
  );
}

export default UnitRefNumbersPreview;
